var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loading)?_c('skeleton-loading',[_c('square-skeleton',{staticStyle:{"width":"100%"},attrs:{"count":10,"box-properties":{
      bottom: '15px',
      height: '15px',
      top: '20px',
    }}})],1):_c('table-component',{attrs:{"columns":_vm.columns,"data":_vm.statements}})}
var staticRenderFns = []

export { render, staticRenderFns }